var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcgimentDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0635 19.8486H13.0635V16.8486L12.0635 15.8486L11.0635 16.8486V19.8486H10.0635C8.96348 19.8486 8.06348 20.7486 8.06348 21.8486V22.8486H16.0635V21.8486C16.0635 21.3182 15.8528 20.8095 15.4777 20.4344C15.1026 20.0593 14.5939 19.8486 14.0635 19.8486Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0635 2.18652L13.7473 7.3689H19.1964L14.788 10.5718L16.4719 15.7542L12.0635 12.5513L7.65509 15.7542L9.33894 10.5718L4.93055 7.3689H10.3796L12.0635 2.18652Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcgimentDrop);
export default __webpack_public_path__ + "static/media/AcgimentDrop.ed255f80ba768c7093d0403de7bcbc61.svg";
export { ForwardRef as ReactComponent };